// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Main from './main.vue'
import AssociatedPartitions from '@partitions/.components/provider/associated_partitions/index.vue'
import New from '@partitions/.components/provider/partitions/new.vue'
import Edit from '@partitions/.components/provider/partitions/edit.vue'

const main_router = 'provider_partitions';
const associated_partitions_router = 'provider_associated_partitions';
const new_router = 'new_provider_partition';
const edit_router = 'edit_provider_partition';

const router = [
    {
        path: '',
        component: Main,
        name: 'provider_partitions',
        meta: {
            api_name: ['api_v1_provider_partitions'],
            breadcrumb: [main_router],
            btns: [new_router, associated_partitions_router],
        }
    },
    {
        path: 'associated_partitions',
        component: AssociatedPartitions,
        name: 'provider_associated_partitions',
        meta: {
            api_name: ['api_v1_provider_associated_partitions'],
            breadcrumb: [main_router, associated_partitions_router],
            btns: [main_router],
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_provider_partition',
        meta: {
            api_name: 'api_v1_provider_partitions_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':partition_identity/edit',
        component: Edit,
        name: 'edit_provider_partition',
        meta: {
            api_name: 'api_v1_provider_partition_update',
            breadcrumb: [main_router, edit_router]
        }
    },
]

export default router;
